<template>
  <BuySpottyModal />
  <RecentSwapsDrawer v-if="isModalOpen" :wallet-address="tonAddress" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getBuyFlowController } from '../controller'
import RecentSwapsDrawer from '../../recent-swaps/RecentSwapsDrawer.vue'
import BuySpottyModal from './BuySpottyModal.vue'
import { useCrosschainBuyRoot } from './composables/useCrosschainBuyRoot'

useCrosschainBuyRoot()

const state = getBuyFlowController().state
const tonAddress = computed(() => state.value.ton.address)
const isModalOpen = computed(() => state.value.isModalOpen)
</script>
